export default __webpack_public_path__ + "static/media/CONTRATO.56baba43.png";